import dayjs from 'dayjs'

export const DATA_START_DATE = dayjs('2019-01-01')
